import { useEffect, useState } from 'react';
import { useBiz } from '../BizContext';

const cache = new Map();

// <img> for files behind the API's bearer auth: fetch as blob, hand the browser an object URL.
export function AuthedImg({ src, alt = '', className, style, onClick, testId }) {
  const { api } = useBiz();
  const [url, setUrl] = useState(cache.get(src) || null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let alive = true;
    if (cache.has(src)) { setUrl(cache.get(src)); return undefined; }
    api.get(src, { responseType: 'blob' }).then((r) => { const u = URL.createObjectURL(r.data); cache.set(src, u); if (alive) setUrl(u); }).catch(() => alive && setFailed(true));
    return () => { alive = false; };
  }, [api, src]);
  if (failed) return <div className={className} style={{ ...style, background: 'var(--paper-3)' }} />;
  if (!url) return <div className={`${className || ''} animate-pulse`} style={{ ...style, background: 'var(--paper-3)' }} />;
  return <img src={url} alt={alt} className={className} style={style} onClick={onClick} data-testid={testId} />;
}

export async function downloadAuthed(api, src, name) {
  const r = await api.get(src, { responseType: 'blob' });
  const u = URL.createObjectURL(r.data);
  const a = document.createElement('a');
  a.href = u; a.download = name || 'file'; a.rel = 'noopener'; a.click();
  setTimeout(() => URL.revokeObjectURL(u), 10000);
}
